import React, { useMemo, useState } from "react"

import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import CardMapping from "../../../helpers/card-mapping"
import CopyContainer from "../../atoms/copy-container"
import FormField from "../../atoms/form-field"
import Grid from "../../atoms/grid"
import Heading from "../../atoms/heading"
import Card from "../../molecules/card"

const Collection = ({
  title,
  description,
  collection,
  color,
  feature,
  filterable,
}) => {
  const { site, allSanityDictionary, allSanityCountry } = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            siteUrl
          }
        }
        allSanityCountry {
          nodes {
            url
            abbreviation
          }
        }
        allSanityDictionary {
          nodes {
            key {
              current
            }
            value
          }
        }
      }
    `
  )

  const country = allSanityCountry.nodes.find(
    (c) => c.url === site.siteMetadata.siteUrl
  ).abbreviation

  const regionCollection = collection.filter(
    (c) => c.country?.abbreviation === country || !c.country
  )

  const [filterQuery, setFilterQuery] = useState("")

  const filteredCollection = useMemo(() => {
    if (!filterQuery) return regionCollection
    const query = filterQuery.toLowerCase()
    return regionCollection.filter((item) =>
      CardMapping(item, allSanityDictionary.nodes)
        .title?.toLowerCase()
        .includes(query)
    )
  }, [regionCollection, filterQuery])

  if (regionCollection.length > 0) {
    let primary = null
    let rest = filteredCollection
    if (feature && filteredCollection.length !== 2) {
      primary = filteredCollection.slice(0, 1)
      rest = filteredCollection.length > 1 ? filteredCollection.slice(1) : null
    }

    return (
      <>
        <Heading>{title}</Heading>
        <CopyContainer content={description} />
        {filterable ? (
          <FormField
            label={
              allSanityDictionary.nodes.find(
                (item) => item.key.current === "collection_filter_label"
              )?.value
            }
            form="collection"
            field="filter"
            type="text"
            value={filterQuery}
            changeEvent={(e) => setFilterQuery(e.target.value)}
          />
        ) : (
          ""
        )}
        {primary ? (
          <Card
            article={CardMapping(primary[0], allSanityDictionary.nodes)}
            variant="primary_feature"
            color={color}
          />
        ) : (
          ""
        )}
        {rest ? (
          <Grid col={Math.min(3, rest.length)}>
            {rest.map((card) => (
              <div>
                <Card
                  article={CardMapping(card, allSanityDictionary.nodes)}
                  variant="labelled"
                />
              </div>
            ))}
          </Grid>
        ) : (
          ""
        )}
      </>
    )
  }
  return ""
}

export default Collection

Collection.propTypes = {
  title: PropTypes.string,
  collection: PropTypes.array,
  description: PropTypes.object,
  color: PropTypes.string,
  feature: PropTypes.bool,
  filterable: PropTypes.bool,
}

Collection.defaultProps = {
  title: "",
  description: null,
  collection: [],
  color: "",
  feature: false,
  filterable: false,
}
